/*global google*/
import { connect } from "react-redux";

import React from "react";
import { Spin, Select } from "antd";
import { selectPdcFromMap, setCurrentDateRange, setPlanningSelectedDate } from "../../../redux/actions/planningActions";
import GoogleMapReact from "google-map-react";
import { fitBounds } from "google-map-react/utils";

import { get, computeFiltersValues, transformSchemaForGps } from "./map.utils";

import SalepointMarker from "./SalepointMarker.component";
import moment from "moment-timezone";
import { GSK_ID, GSK_PHARMA_ID, VACATION_REQUEST_STATUS_ID } from "../../../configs/constants";
import { selectEvents, selectPlanningDate, selectPlanningIsLoading } from "../../../redux/selectors/planningSelector";
import { SelectedDayMap } from "./SelectDayMap";
import { CardEventMap } from "./CardMap";
import { isVisited } from "../planning/Calendar.utils";
import { selectPresenceSelectedUserVacations } from "../../../redux/selectors/presenceSelector";
import { CardVacationMap } from "./CardVacationMap";
const departments = require("./departments.json");
const { Option } = Select;
let google;
const TOKEN = "AIzaSyDxkSpxLuz_dGanirSXNDuvA_6pDDPJafo";
class SimpleMap extends React.Component {
  static googleMap;
  static Polyline;
  static defaultProps = {
    center: {
      lat: 46.765,
      lng: 3.696
    },
    zoom: 6
  };
  state = {
    hoveredPdcId: null,
    center: {
      lat: 46.765,
      lng: 3.696
    },
    zoom: 6,
    nbEventsOfTheDay: 0,
    distancePath: 0,
    durationPath: 0,
    pdcsFiltered: this.props.userPdcsList,
    departmentNb: null,
    frequencyId: undefined,
    cipId: undefined,
    retailersId: [],
    eventsOfTheWeeks: this.props.events.filter(event => moment().isSame(event.start_date, "day")),
    markerDisplayOption: "last_visit_date"
  };
  componentDidMount() {
    this.moveToSector();
    this.props.updateCurrentDateRange(moment().add(-2, "quarter"), moment().add(1, "quarter")); // solution provisoire le temps de faire une api côté back fournissant les dates avec des events/visites
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.userPdcsList) !== JSON.stringify(this.props.userPdcsList)) {
      this.moveToSector();
      this.setState({ pdcsFiltered: this.props.userPdcsList });
    } else if (prevState.departmentNb !== this.state.departmentNb) {
      this.moveToSector();
    } else if (prevProps.selectedPdcId !== this.props.selectedPdcId) {
      const selectedPdc = this.props.userPdcsList.find(pdc => pdc.pdc_id === this.props.selectedPdcId);
      if (
        !selectedPdc ||
        !selectedPdc.gps_lat ||
        parseFloat(selectedPdc.gps_lat) === 0 ||
        !selectedPdc.gps_long ||
        parseFloat(selectedPdc.gps_long) === 0
      ) {
        this.moveToSector();
      } else {
        this.setState({
          center: {
            lat: parseFloat(selectedPdc.gps_lat),
            lng: parseFloat(selectedPdc.gps_long)
          },
          zoom: 15
        });
      }
    }
    if (
      !moment(prevProps.selectedDate).isSame(this.props.selectedDate) ||
      JSON.stringify(prevProps.userPdcsList) !== JSON.stringify(this.props.userPdcsList) ||
      prevProps.events.length !== this.props.events.length
    ) {
      const path = this.computePath();

      if (this.Polyline) {
        this.Polyline.setMap(null);
      }
      if (google) {
        var flightPath = new google.maps.Polyline({
          path: path,
          geodesic: true,
          strokeColor: "#FF0000",
          strokeOpacity: 1.0,
          strokeWeight: 2
        });

        this.Polyline = flightPath;
        this.Polyline.setMap(this.googleMap);
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
          {
            origins: path,
            destinations: path,
            travelMode: "DRIVING"
          },
          (res, status) => {
            let distancePath = 0;
            let durationPath = 0;
            for (let pdc_nb = 0; pdc_nb < path.length - 1; pdc_nb++) {
              if ("OK" === get(["row", pdc_nb, "elements", pdc_nb + 1, "status"], res)) {
                durationPath += res.rows[pdc_nb].elements[pdc_nb + 1].duration.value;
                distancePath += res.rows[pdc_nb].elements[pdc_nb + 1].distance.value;
              }
            }
            this.setState({ distancePath, durationPath });
          }
        );
      }
    }
  }
  computePath = () => {
    const listPdcsWithOldGpsFormat = this.props.userPdcsList.filter(pdc => {
      return (
        (pdc.adresse &&
          pdc.adresse.gpsLat &&
          parseFloat(pdc.adresse.gpsLat) !== 0 &&
          pdc.adresse.gpsLong &&
          parseFloat(pdc.adresse.gpsLong) !== 0) ||
        (pdc.gps_lat && pdc.gps_long && parseFloat(pdc.gps_lat) !== 0 && parseFloat(pdc.gps_long) !== 0)
      );
    });

    const listPdcsWithGps = transformSchemaForGps(listPdcsWithOldGpsFormat);
    const path = [];

    this.props.events
      .filter(event => moment(this.props.selectedDate).isSame(event.start_date, "day"))
      .forEach(event => {
        const pdcOfEvent = listPdcsWithGps.find(pdc => pdc.pdc_id === event.pdc_id);
        if (pdcOfEvent) {
          const gps_lat = pdcOfEvent.gps_lat;
          const gps_long = pdcOfEvent.gps_long;
          path.push({
            lat: gps_lat,
            lng: gps_long
          });
        }
      });

    this.setState({
      nbEventsOfTheDay: path.length
    });
    return path;
  };
  moveToSector = () => {
    const listPdcs = this.state.departmentNb ? this.state.pdcsFiltered : this.props.userPdcsList;
    const listPdcsWithOldGpsFormat = listPdcs.filter(
      pdc =>
        (pdc.adresse &&
          pdc.adresse.gpsLat &&
          parseFloat(pdc.adresse.gpsLat) !== 0 &&
          pdc.adresse.gpsLong &&
          parseFloat(pdc.adresse.gpsLong) !== 0) ||
        (pdc.gps_lat && pdc.gps_long && parseFloat(pdc.gps_lat) !== 0 && parseFloat(pdc.gps_long) !== 0)
    );
    const listPdcsWithGps = transformSchemaForGps(listPdcsWithOldGpsFormat);
    if (listPdcsWithGps.length < 1) {
      alert("Aucun point de vente avec les coordonnées gps renseignées");
      this.setState({
        center: {
          lat: 46.765,
          lng: 3.696
        },
        zoom: 6
      });
    } else {
      const minLat = listPdcsWithGps.reduce((prev, curr) => (prev.gps_lat < curr.gps_lat ? prev : curr)).gps_lat;
      const minLng = listPdcsWithGps.reduce((prev, curr) => (prev.gps_long < curr.gps_long ? prev : curr)).gps_long;
      const maxLat = listPdcsWithGps.reduce((prev, curr) => (prev.gps_lat > curr.gps_lat ? prev : curr)).gps_lat;
      const maxLng = listPdcsWithGps.reduce((prev, curr) => (prev.gps_long > curr.gps_long ? prev : curr)).gps_long;
      const bounds = {
        nw: {
          lat: maxLat,
          lng: minLng
        },
        se: {
          lat: minLat,
          lng: maxLng
        }
      };

      const { center, zoom } = fitBounds(bounds, { width: 600, height: 600 });

      this.setState({ center, zoom });
    }
  };

  onDatePicked = date => {
    const datePicked = date ? date : moment();
    this.setState({
      eventsOfTheWeeks: this.props.events.filter(event => datePicked.isSame(event.start_date, "day"))
    });
    this.props.updateSelectedDate(datePicked);
  };
  handleGoogleMapApi = (map, maps) => {
    this.googleMap = map;
    if (this.Polyline) {
      this.Polyline.setMap();
    }
    const path = this.computePath();
    if (google) {
      var flightPath = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 2
      });

      this.Polyline = flightPath;
      this.Polyline.setMap(map);
      var service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: path,
          destinations: path,
          travelMode: "DRIVING"
        },
        (res, status) => {
          let distancePath = 0;
          let durationPath = 0;
          for (let pdc_nb = 0; pdc_nb < path.length - 1; pdc_nb++) {
            if ("OK" === get(["row", pdc_nb, "elements", pdc_nb + 1, "status"], res)) {
              durationPath += res.rows[pdc_nb].elements[pdc_nb + 1].duration.value;
              distancePath += res.rows[pdc_nb].elements[pdc_nb + 1].distance.value;
            }
          }
          this.setState({ distancePath, durationPath });
        }
      );
    }
  };
  render() {
    const {
      listAvailableDepartments,
      listAvailableRetailers,
      listAvailableFrequencies,
      listAvailableCips
    } = computeFiltersValues(
      this.props.userPdcsList,
      this.state.departmentNb,
      this.state.frequencyId,
      this.state.retailersId,
      this.state.cipId
    );
    const eventsOfTheDay = this.props.events.filter(event =>
      moment(this.props.selectedDate).isSame(event.start_date, "day")
    );
    const vacationsOfTheDay = this.props.vacations.filter(vac =>
      moment(this.props.selectedDate).isBetween(vac.start_date, vac.end_date, "days", "[]")
    );

    const eventsWithVisit = eventsOfTheDay.filter(event => isVisited(event));
    const eventsWithoutVisit = eventsOfTheDay.filter(event => !isVisited(event));

    return (
      <div>
        <div className="p-w-100 p-flex p-al-wrap p-mrg-bot-s">
          <Select
            allowClear={true}
            placeholder="Département"
            style={{ width: 150, marginRight: 10, marginBottom: 10 }}
            onChange={departmentNb => {
              this.setState({
                pdcsFiltered: this.props.userPdcsList.filter(pdc => {
                  if (departmentNb === undefined || departmentNb === null) return true;
                  let pdcZipCode = get(["adresse", "cp"], pdc);
                  let pdcDepartmentNb = pdcZipCode
                    ? pdcZipCode.toString().slice(0, -3) //version hors pharma
                    : pdc.department; // version pharma
                  return pdcDepartmentNb == departmentNb;
                }),
                departmentNb,
                retailersId: [],
                frequency: undefined
              });
            }}
          >
            {departments
              .filter(dep => listAvailableDepartments.indexOf(dep.code) > -1)
              .map(department => {
                return (
                  <Option
                    value={department.code}
                    key={department.id}
                  >{`${department.name} (${department.code})`}</Option>
                );
              })}
          </Select>
          <Select
            value={this.state.retailersId}
            allowClear={true}
            mode="multiple"
            placeholder="Enseigne"
            style={{ width: 150, marginRight: 10, marginBottom: 10 }}
            onChange={retailersId => {
              this.setState({
                pdcsFiltered: this.props.userPdcsList.filter(pdc => {
                  const { departmentNb } = this.state;
                  let pdcZipCode = get(["adresse", "cp"], pdc);
                  let pdcDepartmentNb = pdcZipCode
                    ? pdcZipCode.toString().slice(0, -3) //version hors pharma
                    : pdc.department; // version pharma
                  if (retailersId.length === 0) {
                    return departmentNb === undefined || departmentNb === null || pdcDepartmentNb === departmentNb;
                  }

                  return (
                    (departmentNb === undefined || departmentNb === null || pdcDepartmentNb === departmentNb) &&
                    retailersId.indexOf(pdc.retailer_id) > -1
                  );
                }),
                retailersId
              });
            }}
          >
            {listAvailableRetailers.map(retailer => {
              return <Option value={retailer.id} key={retailer.id}>{`${retailer.label}`}</Option>;
            })}
          </Select>
          <Select
            value={this.state.frequencyId}
            placeholder="Fréquence"
            allowClear={true}
            style={{ width: 150, marginRight: 10, marginBottom: 10 }}
            onChange={frequencyId => {
              this.setState({
                pdcsFiltered: this.props.userPdcsList.filter(pdc => {
                  if (frequencyId === undefined || frequencyId === null) return true;

                  return frequencyId == pdc.frequency;
                }),
                frequencyId
              });
            }}
          >
            {listAvailableFrequencies.map((frequency, i) => {
              return <Option value={frequency.id} key={frequency.id || i}>{`${frequency.label}`}</Option>;
            })}
          </Select>
          {this.props.currentClientId === GSK_PHARMA_ID && (
            <Select
              value={this.state.cipId}
              placeholder="CIP"
              style={{ width: 150, marginRight: 10, marginBottom: 10 }}
              onChange={cipId => {
                this.setState({
                  pdcsFiltered: this.props.userPdcsList.filter(pdc => {
                    if (cipId === undefined || cipId === null) return true;

                    return cipId == pdc.cip;
                  }),
                  cipId
                });
              }}
            >
              {listAvailableCips.map((cip, i) => {
                return <Option value={cip.id} key={cip.id || i}>{`${cip.label}`}</Option>;
              })}
            </Select>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 10,
              marginBottom: 10
            }}
          >
            <label style={{ marginRight: 10 }}>Type de coloration :</label>
            <Select
              value={this.state.markerDisplayOption}
              placeholder="Affichage marqueur"
              style={{ width: 150 }}
              onChange={value => this.setState({ markerDisplayOption: value })}
            >
              <Option value="pdl">PDL</Option>
              <Option value="dn">DN</Option>
              <Option value="last_visit_date">Date dernière visite</Option>
            </Select>
          </div>
        </div>
        <div className="p-calendar-map p-flex">
          <div className="p-calendar-map-carte p-mrg-bot-l p-w-100">
            <GoogleMapReact
              bootstrapURLKeys={{ key: TOKEN }}
              defaultCenter={this.props.center}
              defaultZoom={this.props.zoom}
              center={this.state.center}
              zoom={this.state.zoom}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => this.handleGoogleMapApi(map, maps)}
            >
              {!this.props.isLoadingPlanning && this.props.selectedSector ? (
                this.state.pdcsFiltered
                  .filter(
                    pdc =>
                      (pdc.adresse &&
                        pdc.adresse.gpsLat &&
                        parseFloat(pdc.adresse.gpsLat) !== 0 &&
                        pdc.adresse.gpsLong &&
                        parseFloat(pdc.adresse.gpsLong) !== 0) ||
                      (pdc.gps_lat && pdc.gps_long && parseFloat(pdc.gps_lat) !== 0 && parseFloat(pdc.gpsLong) !== 0)
                  )
                  .map(pdc => ({
                    ...pdc,
                    gps_lat: parseFloat(pdc.gps_lat) || parseFloat(pdc.adresse.gpsLat),
                    gps_long: parseFloat(pdc.gps_long) || parseFloat(pdc.adresse.gpsLong)
                  }))
                  .map(pdc => {
                    return (
                      <SalepointMarker
                        key={pdc.pdc_id}
                        lat={parseFloat(pdc.gps_lat)}
                        lng={parseFloat(pdc.gps_long)}
                        isPdcPlanned={this.state.eventsOfTheWeeks
                          .filter(event => moment(this.props.selectedDate).isSame(event.start_date, "day"))
                          .some(event => event.pdc_id === pdc.pdc_id)}
                        pdcLabel={pdc.pdc_label}
                        last_visit_date={pdc.last_visit_date}
                        dn={pdc.dn}
                        pdl={pdc.pdl}
                        hover={pdc.pdc_label}
                        retailerId={pdc.retailer_id}
                        hoverPdc={this.state.hoveredPdcId === pdc.pdc_id}
                        onHover={bool =>
                          this.setState({
                            hoveredPdcId: bool ? pdc.pdc_id : null
                          })
                        }
                        onClick={() => {
                          this.props.selectPdcFromMap(pdc);
                          this.props.displayEventCreationModal();
                        }}
                        displayOption={this.state.markerDisplayOption}
                      />
                    );
                  })
              ) : (
                <Spin lat={this.state.center.lat} lng={this.state.center.lng} tip={"chargement"} />
              )}
            </GoogleMapReact>
          </div>
          <div className="p-calendar-map-pdcs p-pdg-left-l">
            <div className="p-calendar-map-pdcs-title">
              Choisir une date afin de voir les visites planifiées ce jour :
            </div>
            <SelectedDayMap onDatePicked={this.onDatePicked} currentDate={this.props.selectedDate} />

            <div className="p-calendar-map-pdcs-nb">
              {`${this.state.nbEventsOfTheDay} visite${this.state.nbEventsOfTheDay > 1 ? "s" : ""} planifiée${
                this.state.nbEventsOfTheDay > 1 ? "s" : ""
              }`}
            </div>
            <div style={{ color: "#949494", fontSize: 12 }}>{`Distance parcourue prévue (version beta vol d'oiseau) : ${
              this.googleMap && this.Polyline && get(["maps", "geometry", "spherical"], google, 0)
                ? parseInt(google.maps.geometry.spherical.computeLength(this.Polyline.getPath().getArray()) / 1000)
                : 0
            } km - temps de parcours : ?`}</div>
            {/* ${this.state.durationPath} secondes)`}</div> */}

            {vacationsOfTheDay.length > 0 && (
              <div>
                <div className="text-3xl m-5">{`${vacationsOfTheDay.length} congé${
                  vacationsOfTheDay.length > 1 ? "s" : ""
                } prévu${vacationsOfTheDay.length > 1 ? "s" : ""}  ce jour`}</div>
                {vacationsOfTheDay.map(vac => (
                  <CardVacationMap vacation={vac} />
                ))}
              </div>
            )}
            <div className="p-mrg-top">
              <div className="text-3xl m-5">Visites planifiées</div>
              {eventsWithoutVisit.length > 0
                ? eventsWithoutVisit.map(event => {
                    return (
                      <CardEventMap
                        event={event}
                        hoverPdcId={this.state.hoveredPdcId}
                        setHoveredPdcId={pdcId => {
                          this.setState({ hoveredPdcId: pdcId });
                        }}
                      />
                    );
                  })
                : "Plus de visites plannifiées aujourd'hui"}
              <div className="text-3xl m-5">Visites effectuées</div>
              {eventsWithVisit.length > 0
                ? eventsWithVisit.map(event => {
                    return (
                      <CardEventMap
                        event={event}
                        hoverPdcId={this.state.hoveredPdcId}
                        setHoveredPdcId={pdcId => {
                          this.setState({ hoveredPdcId: pdcId });
                        }}
                      />
                    );
                  })
                : "Aucune visite faite ce jour"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const vacationsValidated = selectPresenceSelectedUserVacations(state).filter(
    vacation => get(["status", "id"], vacation, 0) === VACATION_REQUEST_STATUS_ID.VALIDATED
  );

  return {
    isLoadingPlanning: selectPlanningIsLoading(state),
    selectedSector: state.planning.selectedSector,
    selectedPdcId: state.planning.selectedPdcId,
    userPdcsList: state.planning.userPdcs || [],
    currentClientId: currentClient.id || 0,
    selectedDate: selectPlanningDate(state),
    vacations: vacationsValidated.map(vacation => ({
      start_date: moment(vacation.start),
      end_date: moment(vacation.end),
      title: vacation.title,
      duration: vacation.duration
    })),
    events: selectEvents(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectPdcFromMap: pdc => dispatch(selectPdcFromMap(pdc)),
    updateSelectedDate: date => dispatch(setPlanningSelectedDate(date)),
    setCurrentDateRange: range => dispatch(setCurrentDateRange(range))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SimpleMap);



// WEBPACK FOOTER //
// src/containers/activite/map/map.container.google.js